import React from 'react';
import './sobre.css';
import { AnimationOnScroll } from 'react-animation-on-scroll';

import sobreImg from '../../assets/sobre-img2.jpeg';
import google5 from '../../assets/google5.webp';

const Sobre = () => {
  return (
    <div className="psico__sobre sobre__margin" id="sobre">
      <div className="psico__sobre-content">

        <div className="psico__sobre-img">
          <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
            <img src={sobreImg} alt="Foto do profissional André Parreira durante um atendimento." />
          </AnimationOnScroll>
        </div>

        <div className="psico__sobre-content__about">

          <div className="psico__sobre-content__about-title">
            <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
              {/* <h2>Sobre o Dr. André Parreira</h2> */}
              <h2>Sobre Mim</h2>
            </AnimationOnScroll>
          </div>

          <div className="psico__sobre-content__about-title__broken">
            <AnimationOnScroll animateIn="slide-in-left" duration={1}>
              <h2>Sobre o</h2>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="slide-in-left" duration={1} delay={700}>
              <h2>Dr. André Parreira</h2>
            </AnimationOnScroll>
          </div>

          <div className="psico__sobre-content__about-text">
            <AnimationOnScroll animateIn="slide-in-right" duration={1.5}>
              <div className="texto-aumentado-titulo">
                <p><strong>Psicólogo André Parreira</strong><br />CRP 06/197081</p>
              </div>

              <p>
                Sou André Parreira, psicólogo formado pela <strong>Universidade Presbiteriana Mackenzie</strong>, com especialização em <strong>Psicologia Clínica e aprimoramento internacional</strong>. Minha missão é ajudar você a superar desafios emocionais e construir uma vida com mais equilíbrio, clareza, propósito e bem-estar.
              </p>

              <p><strong>PORQUE ESCOLHER O MEU TRABALHO?</strong></p>

              <p><strong>✨ Experiência que gera resultados:</strong></p>
              <p className="emoji-line">
                {/* ✔️ <strong>+7.000 horas de prática clínica</strong> em atendimentos individuais e em grupo.<br />
                ✔️ <strong>+7 anos dedicados exclusivamente à prática clínica e 10 anos de trajetória na saúde mental.</strong><br />
                ✔️ <strong>+420 pessoas atendidas</strong>, acompanhando histórias de transformações reais. */}
                ✔️ <strong>+400 Pacientes Transformados.</strong><br />
                ✔️ <strong>+8 anos de Prática Clínica.</strong><br />
                ✔️ <strong>+7.600 horas de Atendimento Psicológico.</strong>
              </p>

              <p><strong>✨ Atendimento de excelência:</strong></p>
              <p className="emoji-line">
                {/* 🔹 Abordagem personalizada, centrada nas suas necessidades.<br />
                🔹 Metodologia estruturada, baseada em evidências, com especialização internacional. */}
                Não ofereço apenas escuta, mas um <strong>Processo Terapêutico direcionado, claro e focado em resultados = VOCÊ!</strong>
              </p>

              {/* <p><strong>✨ Depoimentos Reais:</strong></p>
              <p className="emoji-line">
                Veja como a terapia tem transformado a vida de centenas de pessoas — <strong>avaliação 5/5 por quem já viveu essa jornada</strong>.
              </p>

              <p>
                Clique aqui para conferir:
              </p> */}

              {/* <div className="psico__sobre-content__about-text__top5">
                <div className="b_container">
                  <a target="_blank" rel="noreferrer" href="https://www.google.com/search?q=Psic%C3%B3logo+Andr%C3%A9+Parreira">
                    <img src={google5} alt="Avaliação 5 estrelas no Google." />
                  </a>
                </div>
                <div className="img_container">
                  <p></p>
                </div>
              </div>

              <div className="psico__sobre-content__about-text__top5Mobile">
                <div className="b_containerMobile">
                  <a target="_blank" rel="noreferrer" href="https://www.google.com/search?q=Psic%C3%B3logo+Andr%C3%A9+Parreira">
                    <img src={google5} alt="Avaliação 5 estrelas no Google." />
                  </a>
                </div>
              </div> */}
            </AnimationOnScroll>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sobre;
